<template>
  <div class="content">
    <van-nav-bar title="散客票列表" left-text="" right-text="订单信息" left-arrow @click-left="onClickLeft"
      @click-right="onClickRight" />
    <van-loading type="spinner" class='loading' color="#1989fa" />
    <!-- vant空状态 -->
    <van-notice-bar color="" left-icon="volume-o">
      {{headr}}
    </van-notice-bar>
    <van-row style="padding-bottom: 70px;">
      <div>
        <van-row>
          <van-col span="12" v-if="hide1">
            <span style="display: inline-block;height:20px; width: 100%; text-align: center;color: black;
				   		font-size: 14px; line-height: 40px; background:#ffffff; font-weight: 600;" @click="jc">
              散客计次票
            </span>

            <span style="display: inline-block; margin-top: -20px; height:3px; width: 100%; text-align: center;">
              <span style="display:inline-block;  height:1px; width: 20%; border: 1px solid salmon; background-color: #FF4A53; "></span>
            </span>

          </van-col>
          <van-col span="12" v-if="hide1">
            <span @click="js" style="display: inline-block;height: 40px;
			 			line-height: 40px; width: 100%;

			 			text-align: center;
			 			color: #999999FF;
			 			font-size: 14px;">
              散客计时票
            </span>
          </van-col>
          <van-col span="12" v-if="hide2">
            <span style="display: inline-block;height: 40px;
			 			line-height: 40px; width: 100%;

			 			text-align: center;
			 			color: #999999FF;
			 			font-size: 14px;" @click="jc">
              散客计次票
            </span>
          </van-col>

          <van-col span="12" v-if="hide2">
            <span @click="js" style="display: inline-block;height:20px; width: 100%; text-align: center;color: black;
				   		font-size: 14px; line-height: 40px; background:ffffff; font-weight: 600;">
              散客计时票
            </span>
            <span style="display: inline-block; margin-top: -20px; height:3px; width: 100%; text-align: center;">
              <span style="display:inline-block;  height:1px; width: 20%; border: 1px solid salmon; background-color: #FF4A53; "></span>
            </span>

          </van-col>

        </van-row>
      </div>
      <div v-for="(item,index) in carts" :key="index" id="ticket_list" style="margin-top: 12px;" v-if="hide1">
        <van-row>
          <van-col span="24">
            <van-col span="8">
              <el-image style="width:90%; height:98px; margin-left: 5%; border-radius: 10px; background-size: cover;"
                :src="item.thumb"></el-image>
            </van-col>

            <van-col span="16">
              <van-col span="17" style="margin-top:-2px;
                    padding-left: 5px;font-size: 14px;
                    font-weight:600; color:#000000 ;">
                {{item.title}}
              </van-col>
              <van-col span="7" style="margin-top: -2px; padding-left: 0px;">
                <s style="color:gray;"><span style=" font-size: 16px; font-weight: 700;"> ￥{{item.ticketDisplayPrice}} </span></s>
              </van-col>
              <van-col span="17" style="margin-top: 10px; font-size: 12px; padding-left: 5px;">
                <span class="box_list">{{item.mode}}票</span> <span style="display: none;" class="box_list"> {{item.isAppointmentEnable}}</span>
                <span style="display: inline-block; font-size: 12px;" class="box_list"> {{item.isAppointmentEnable_}}</span>
                <span style="display: none;" class="box_list"> {{item.isRefundCheck}}</span>



                <span style="font-size: 12px;" class="box_list"> {{item.isRefundCheck_}}</span>

              </van-col>

              <van-col span="7" style="margin-top: 10px; padding-left: 0px;">
                <span style="color:#FF4924FF ; font-size: 16px; font-weight: 700;"> ￥{{item.price}} </span>
              </van-col>


               <van-col span="12" style="margin-top:15px; font-size: 12px; padding-left: 5px;">
                 <span style="font-size: 12px; color: #333333; "  @click="yuding_(index)">预订须知<van-icon name="arrow" /></span>
              </van-col>
              <!-- <van-col span="12" style="margin-top:10px; text-align:right; padding-right: 5px;">
                   <van-button round  @click="onSubmit(index)" size="small" color="#FF4924FF"  style="width:80px; height: 25px;">立即购买</van-button>
              </van-col> -->
              <van-col span="12" style="margin-top:10px; text-align:right; padding-right: 5px;">
                   <van-button round  @click="onSubmit(index)" size="small" color="#FF4924FF"  style="width:80px; height: 25px;">立即预订</van-button>
              </van-col>

            </van-col>
          </van-col>
        </van-row>
      </div>

      <div v-for="(item,index) in carts_" :key="index" style="padding-top: 12px;" v-if="hide2">
        <van-row>
          <van-col span="24">
            <van-col span="8">
              <el-image style="width:90%; height:90px; margin-left: 5%; border-radius: 10px; background-size: cover;" :src="item.thumb"></el-image>
            </van-col>
            <van-col span="16">
             <van-col span="17" style="margin-top:-2px;
                   padding-left: 5px;font-size: 14px;
                   font-weight:600; color:#000000 ;">
               {{item.title}}
             </van-col>
             <van-col span="7" style="margin-top: -2px; padding-left: 0px;">
               <s style="color:gray;"><span style=" font-size: 16px; font-weight: 700;"> ￥{{item.ticketDisplayPrice}} </span></s>
             </van-col>
             <van-col span="17" style="margin-top: 10px; font-size: 12px; padding-left: 5px;">
               <span class="box_list">{{item.mode}}票</span> <span style="display: none;" class="box_list"> {{item.isAppointmentEnable}}</span>
               <span style="display: inline-block; font-size: 12px;" class="box_list"> {{item.isAppointmentEnable_}}</span>
               <span style="display: none;" class="box_list"> {{item.isRefundCheck}}</span>

               <span style="font-size: 12px;" class="box_list"> {{item.isRefundCheck_}}</span>

             </van-col>

             <van-col span="7" style="margin-top: 10px; padding-left: 0px;">
               <span style="color:#FF4924FF ; font-size: 16px; font-weight: 700;"> ￥{{item.price}} </span>
             </van-col>


              <van-col span="12" style="margin-top:15px; font-size: 12px; padding-left: 5px;">
                <span style="font-size: 12px; color: #333333; "  @click="yuding_a(index)">预订须知<van-icon name="arrow" /></span>
             </van-col>
             <van-col span="12" style="margin-top:10px; text-align:right; padding-right: 5px;">
                  <van-button round  @click="onSubmit_(index)" size="small" color="#FF4924FF"  style="width:80px; height: 25px;">立即预订</van-button>
             </van-col>
        <!--     <van-col span="12" style="margin-top:10px; text-align:right; padding-right: 5px;">
                 <van-button round  @click="onSubmit_(index)" size="small" color="#FF4924FF"  style="width:80px; height: 25px;">立即购买</van-button>
             </van-col> -->

            </van-col>
          </van-col>
        </van-row>
      </div>
    </van-row>
  <!--  <van-submit-bar button-text="提交订单" @submit="onSubmit" v-if="hide1">
      <template>
        <div id="numlist">
          <van-row>
            <van-col span="24">
              <van-col span="5">
                <span class="xz" @click="xz()" style="margin-right:2px;">预订须知</span>
              </van-col>
              <van-col span="8">
                <span style="margin-left:10px;">已选:{{numlist}}</span>
                <span v-if="hide">{{numdata}}</span>
              </van-col>
              <van-col span="11">
                <span class="total">合计:￥<span class="" style="font-weight: 300;font-size: 14px;
						   color:#FF4A53 ; display: inline-block;text-align: left;">{{total}}</span></span>
              </van-col>
            </van-col>
          </van-row>
        </div>
      </template>
    </van-submit-bar> -->
    <!-- vant提交订单栏 -->
   <!-- <van-submit-bar button-text="提交订单" @submit="onSubmit_" v-if="hide2">
      <template>
        <div id="numlist">
          <van-row>
            <van-col span="24">
              <van-col span="5">
                <span class="xz" @click="xz()" style="margin-right:2px; font-size: 12px;">预订须知</span>
              </van-col>
              <van-col span="8">
                <span style="margin-left:10px;">已选:{{numlist_}}</span>
                <span v-if="hide">{{numdata_}}</span>
              </van-col>
              <van-col span="11">
                <span class="total">合计:{{total_}}</span>
              </van-col>
            </van-col>
          </van-row>
        </div>
      </template>
    </van-submit-bar> -->

      <van-popup
        v-model="show_yuding"
        closeable
        position="bottom"
        :style="{ height: '40%' }"
        >

         <van-col span="24" style="margin-top: 40px;">
           <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
             <span style="color:#000000 ; font-size: 15px; font-weight: 800;">购票须知</span>
           </van-col>
           <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
             <span style="color:#000000 ; font-size: 15px; font-weight: 800;">{{title}}</span>
           </van-col>
           <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
             <span style="color:#000000 ; font-size: 15px; "> 预订说明</span>
           </van-col>
            <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
              <span style="color:#333333 ; font-size: 12px; ">单价: ￥{{price}}</span>
            </van-col>
            <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
              <span style="color:#333333 ; font-size: 12px; ">项目说明:{{detailsExplain}} </span>
            </van-col>

            <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
              <span style="color:#000000 ; font-size: 15px; ">使用说明</span>
            </van-col>
            <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
              <span style="color:#333333 ; font-size: 12px; ">使用方法: {{reservationInstructions}}</span>
            </van-col>
            <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
              <span style="color:#333333 ; font-size: 12px; ">入园时间:{{enterMode}}</span>
            </van-col>
        </van-col>

      </van-popup>
      <van-popup
        v-model="show_yuding_"
        closeable
        position="bottom"
        :style="{ height: '40%' }"
        >

         <van-col span="24" style="margin-top: 40px;">
           <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
             <span style="color:#000000 ; font-size: 15px; font-weight: 800;">购票须知</span>
           </van-col>
           <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
             <span style="color:#000000 ; font-size: 15px; font-weight: 800;">{{title_}}</span>
           </van-col>
           <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
             <span style="color:#000000 ; font-size: 15px; "> 价格说明</span>
           </van-col>
            <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
              <span style="color:#333333 ; font-size: 12px; ">单价: ￥{{price_}}</span>
            </van-col>
            <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
              <span style="color:#333333 ; font-size: 12px; ">使用日期: 选择的游玩时间开始生效</span>
            </van-col>

            <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
              <span style="color:#000000 ; font-size: 15px; ">使用说明</span>
            </van-col>
            <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
              <span style="color:#333333 ; font-size: 12px; ">使用方法: 凭电子二维码可直接入园</span>
            </van-col>
            <van-col span="24" style="margin-top: 5px; padding-left: 5px;">
              <span style="color:#333333 ; font-size: 12px; ">入园时间: 08:00-18:00</span>
            </van-col>
        </van-col>

      </van-popup>
    <!--<van-tabbar v-model="active">
		    <van-tabbar-item icon="home-o"><router-link to="/wx_ticketIndex" class="router">购票首页</router-link></van-tabbar-item>
		    <van-tabbar-item icon="search"><router-link to="/wx_ticketOrder" class="router">我的订单</router-link></van-tabbar-item>
		   <van-tabbar-item icon="setting-o"><router-link to="/wx_ticketUser" class="router">个人中心</router-link></van-tabbar-item>
		</van-tabbar>-->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        show_yuding: false,
         show_yuding_: false,
        hide2: false,
        hide1: true,
        hide: false,
        carts: [], //添加到计次票
        carts_: [], //添加到计时票
        headr: '',
        xxid: "",
        jieshao: "",
        directionsForUse: "",
        dizhi: "",
        yuding: "",
        tuigai: "",
        qupiao: "",
        numdata: '0',
        numdata_: '0',
        title:"",
        title_:"",
        price:"",
        price_:"",
        enterMode:"",
        saleStartTime:"",
        saleEndTime:"",
        isRealName:"",
        limitCount:"",
        detailsExplain:"",
        reservationInstructions:"",
      }
    },
    mounted() {
      this.ticketlist();
      this.xxquery();
    },

    computed: {

      total: function() { //计算总价
        let total = 0
        for (var i = 0; i < this.carts.length; i++) {
          var item = this.carts[i];
          total += item.price * item.num
        }
        return total;
      },
      numlist: function() {
        var num = 0;
        for (var i = 0; i < this.carts.length; i++) {
          var item = this.carts[i];
          num += item.num;
        }
        this.numdata = num;
        return num;
      },
      total_: function() { //计算总价
        let total = 0
        for (var i = 0; i < this.carts_.length; i++) {
          var item = this.carts_[i];
          total += item.price * item.num
        }

        return total;
      },
      numlist_: function() {
        var num_ = 0;
        for (var i = 0; i < this.carts_.length; i++) {
          var item = this.carts_[i];
          num_ += item.num;
        }
        this.numdata_ = num_;
        return num_;
      },
    },
    methods: {
      yuding_a(index) {
             this.show_yuding_= true;
             console.log(index)
             this.title_=this.carts_[index].title;
             this.price_= this.carts_[index].price;
             this.enterMode= this.carts_[index].enterMode;
             this.detailsExplain= this.carts_[index].detailsExplain;
             this.reservationInstructions= this.carts_[index].reservationInstructions;
             this.saleStartTime= this.carts_[index].saleStartTime;
             this.saleEndTime= this.carts_[index].saleEndTime;
             this.isRealName= this.carts_[index].isRealName;
              this.limitCount= this.carts_[index].limitCount;
             console.log(this.carts_)
        },
       yuding_(index) {
            this.show_yuding= true;
            console.log(index)
            this.title=this.carts[index].title;
            this.price= this.carts[index].price;
            this.enterMode= this.carts[index].enterMode;
            this.detailsExplain= this.carts[index].detailsExplain;
            this.reservationInstructions= this.carts[index].reservationInstructions;
            this.saleStartTime= this.carts[index].saleStartTime;
            this.saleEndTime= this.carts[index].saleEndTime;
            this.isRealName= this.carts[index].isRealName;
            this.limitCount= this.carts[index].limitCount;
            console.log(this.carts)
        },
      jc() {
        console.log("11")
        this.hide1 = true;
        this.hide2 = false;
        this.ticketlist();
        this.numdata_ = '';
        this.numdata = '';

      },
      js() {
        console.log("22")
        this.hide2 = true;
        this.hide1 = false;
        this.ticketlist_()
        this.numdata_ = '';
        this.numdata = '';


      },
      ticketlist() {
        let storage = window.sessionStorage;
        let token = storage.getItem("token")
        let scenicAreaID = storage.getItem("scenicAreaID");
        let isLoadThirdPlatform = 1;
        let ticketCateArray = [0];
        let ticketFeeMethoda = 0;
        this.$axios({
            // url: "/api/ticketType/select",
            url: "/api/ticketType",
            method: "get",
            params: {
              pageItems: 999, //每页显示的条数
              pageNumber: 1, //页数
              ticketCateArray: ticketCateArray,
              scenicAreaID: scenicAreaID,
              ticketFeeMethod: ticketFeeMethoda,
              isLoadThirdPlatform: isLoadThirdPlatform
            },
            headers: {
              "authorization": token,
              "Content-Type": "application/json; charset=utf-8"
            }
          })
          .then(res => {
            console.log(res.data)
            var data = res.data[0];
            this.carts = [];
            for (const i in data) {
              if (data[i].ticketFeeMethod == 0) {
                var ticketFeeMethod = "计次";
              }
              if (data[i].ticketFeeMethod == 1) {
                var ticketFeeMethod = "计时";
              }
              if (data[i].ticketFeeMethod == 2) {
                var ticketFeeMethod = "按天数";
              }
              var headPhoto = "";
              if (data[i].photoPathLogo == '') {
                headPhoto = "../../../../../static/upload.png"
              } else {
                headPhoto = "/api/image?url=" + data[i].photoPathLogo;
              }
              if(data[i].isAppointmentEnable==1){
                var  isAppointmentEnable_="分时预约"
              }else{
                var isAppointmentEnable_="预订"
              }
              if(data[i].isRefundCheck==1){
                var  isRefundCheck_="退需审核"
              }else{
                var isRefundCheck_="无需审核"
              }
            this.carts.push({
                id: data[i].id,
                num: 0,
                title: data[i].ticketTypeName,
                price: data[i].ticketPrice,
                thumb: headPhoto,
                mode: ticketFeeMethod,
                isAppointmentEnable: data[i].isAppointmentEnable,
                isAppointmentEnable_:isAppointmentEnable_,
                isRefundCheck:data[i].isRefundCheck,
                isRefundCheck_:isRefundCheck_,
                ticketDisplayPrice:data[i].ticketDisplayPrice,
                reservationInstructions:data[i].reservationInstructions,
                detailsExplain:data[i].detailsExplain,
                enterMode:data[i].enterMode,
                saleStartTime:data[i].saleStartTime,
                saleEndTime:data[i].saleEndTime,
                isRealName:data[i].isRealName,
                limitCount:data[i].limitCount,
              });
            }
            this.tableDataLength = res.data[1];
          })
          .catch(err => {
            console.log(err);
          });
      },
      ticketlist_() {

        let storage = window.sessionStorage;
        let token = storage.getItem("token")
        let scenicAreaID = storage.getItem("scenicAreaID");
        let isLoadThirdPlatform = 1;
        let ticketCateArray = [0];
        let ticketFeeMethoda = 1;
        this.$axios({
            // url: "/api/ticketType/select",
            url: "/api/ticketType",
            method: "get",
            params: {
              pageItems: 999, //每页显示的条数
              pageNumber: 1, //页数
              ticketCateArray: ticketCateArray,
              scenicAreaID: scenicAreaID,
              ticketFeeMethod: ticketFeeMethoda,
              isLoadThirdPlatform: isLoadThirdPlatform
            },
            headers: {
              "authorization": token,
              "Content-Type": "application/json; charset=utf-8"
            }
          })
          .then(res => {
            console.log(res.data)
            var data = res.data[0];
            this.carts_ = [];
            for (const i in data) {
              if (data[i].ticketFeeMethod == 0) {
                var ticketFeeMethod = "计次";
              }
              if (data[i].ticketFeeMethod == 1) {
                var ticketFeeMethod = "计时";
              }
              if (data[i].ticketFeeMethod == 2) {
                var ticketFeeMethod = "按天数";
              }

              var headPhoto = "";
              if (data[i].photoPathLogo == '') {
                headPhoto = "../../../../../static/upload.png"
              } else {
                headPhoto = "/api/image?url=" + data[i].photoPathLogo;
              }
              if(data[i].isAppointmentEnable==1){
                var  isAppointmentEnable_="分时预约"
              }else{
                var isAppointmentEnable_="即买即用"
              }
              if(data[i].isRefundCheck==1){
                var  isRefundCheck_="退需审核"
              }else{
                var isRefundCheck_="无需审核"
              }
              this.carts_.push({
                id: data[i].id,
                num: 0,
                title: data[i].ticketTypeName,
                price: data[i].ticketPrice,
                thumb: headPhoto,
                mode: ticketFeeMethod,
                isAppointmentEnable: data[i].isAppointmentEnable,
                isAppointmentEnable_:isAppointmentEnable_,
                isRefundCheck:data[i].isRefundCheck,
                isRefundCheck_:isRefundCheck_,
                ticketDisplayPrice:data[i].ticketDisplayPrice,
                reservationInstructions:data[i].reservationInstructions,
                detailsExplain:data[i].detailsExplain,
                enterMode:data[i].enterMode,
                saleStartTime:data[i].saleStartTime,
                saleEndTime:data[i].saleEndTime,
                isRealName:data[i].isRealName,
                limitCount:data[i].limitCount,

              });
            }
            this.tableDataLength = res.data[1];
          })
          .catch(err => {
            console.log(err);
          });
      },
      xxquery() {
        let storage = window.sessionStorage;
        let token = storage.getItem("token")
        let scenicAreaID = storage.getItem("scenicAreaID");
        this.$axios({
            url: "/api/wechatPublicConfig",
            method: "get",
            params: {
              pageItems: 999, //每页显示的条数
              pageNumber: 1, //页数
              scenicAreaID: scenicAreaID,

            },
            headers: {
              "authorization": token,
              "Content-Type": "application/json; charset=utf-8"
            },
            
          })
          .then(res => {
            var data = res.data[0];
            this.headr = data[0].serviceTel;
            this.xxid = data[0].id;
            this.jieshao = data[0].scenicIntroduction;
            this.dizhi = data[0].scenicAddress;
            this.yuding = data[0].dueToThat;
            this.tuigai = data[0].backToThat;
            this.qupiao = data[0].takeTicketAddress;
            this.directionsForUse = data[0].directionsForUse;

          })
          .catch(err => {
            console.log(err);
          });
      },
      jia(index) {
        this.carts[index].num++;
      },
      jie(index) {
        if (this.carts[index].num === 0) return;
        this.carts[index].num--;
      },
      jia_(index) {
        this.carts_[index].num++;
      },
      jie_(index) {
        if (this.carts_[index].num === 0) return;
        this.carts_[index].num--;
      },
      onSubmit(index) {
        let storage = window.sessionStorage;
        let scenicAreaID = this.scenicArea;
        let token = storage.getItem("token")
        console.log(this.carts)
        let ticketTypeName=this.carts[index].title;
        let ticketTypeID= this.carts[index].id;
        let isAppointmentEnable= this.carts[index].isAppointmentEnable;
        let isRefundCheck= this.carts[index].isRefundCheck;
        let price= this.carts[index].price;
        let enable_id=isAppointmentEnable;
        let enterMode= this.carts[index].enterMode;
        let detailsExplain= this.carts[index].detailsExplain;
        let reservationInstructions= this.carts[index].reservationInstructions;
        let saleStartTime= this.carts[index].saleStartTime;
        let saleEndTime= this.carts[index].saleEndTime;
        let isRealName= this.carts[index].isRealName;
        let limitCount= this.carts[index].limitCount;
     //   let ticketArray = ticketlist;
        this.$router.push({
          path: "/wx_ticketOrder",
          query: {
            enable_id:enable_id,
             ticketTypeName:ticketTypeName,
             ticketTypeID: ticketTypeID,
             isAppointmentEnable:isAppointmentEnable,
             isRefundCheck:isRefundCheck,
             price:price,
             reservationInstructions:reservationInstructions,
             enterMode:enterMode,
             detailsExplain:detailsExplain,
             saleStartTime:saleStartTime,
             saleEndTime:saleEndTime,
             isRealName:isRealName,
             limitCount:limitCount,
          },
          headers: {
            "authorization": token,
            "Content-Type": "application/json; charset=utf-8"
          },
        });

      },
      onSubmit_(index) {
        let storage = window.sessionStorage;
        let scenicAreaID = this.scenicArea;
        let token = storage.getItem("token")
        console.log(this.carts_)
        let ticketTypeName=this.carts_[index].title;
        let ticketTypeID= this.carts_[index].id;
        let isAppointmentEnable= this.carts_[index].isAppointmentEnable;
        let isRefundCheck= this.carts_[index].isRefundCheck;
        let price= this.carts_[index].price;
        let enable_id=isAppointmentEnable;
        let enterMode= this.carts_[index].enterMode;
        let detailsExplain= this.carts_[index].detailsExplain;
        let reservationInstructions= this.carts_[index].reservationInstructions;
        let saleStartTime= this.carts_[index].saleStartTime;
        let saleEndTime= this.carts_[index].saleEndTime;
        let isRealName= this.carts_[index].isRealName;
        let limitCount= this.carts_[index].limitCount;
     //   let ticketArray = ticketlist;
        this.$router.push({
            path: "/wx_ticketOrder",
            query: {
              enable_id:enable_id,
               ticketTypeName:ticketTypeName,
               ticketTypeID: ticketTypeID,
               isAppointmentEnable:isAppointmentEnable,
               isRefundCheck:isRefundCheck,
               price:price,
               reservationInstructions:reservationInstructions,
               enterMode:enterMode,
               detailsExplain:detailsExplain,
               saleStartTime:saleStartTime,
               saleEndTime:saleEndTime,
               isRealName:isRealName,
               limitCount:limitCount,

            },
            headers: {
              "authorization": token,
              "Content-Type": "application/json; charset=utf-8"
            }
          });

        },
      onClickLeft() {
        this.$router.push({
          path: "/wx_ticketIndex"
        });
      },
      onClickRight() {
        this.$router.push({
          path: "/wx_ticketOrderlist"
        });
      },
      xz() {
        /* this.xxid=data[0].id;
					   this.jieshao=data[0].scenicIntroduction;
				  	   this.dizhi =data[0].scenicAddress;
				  	   this.yuding =data[0].dueToThat;
				  	   this.tuigai =data[0].backToThat;
	 				   this.qupiao=data[0].takeTicketAddress;*/
        let text =

          "【开园时间】:" + this.qupiao + "<br/>" +
          "【联系电话】:" + this.directionsForUse + "<br/>" +
          "【预订使用说明】:" + this.yuding + "<br/>" +
          "【退改说明】:" + this.tuigai;

        this.$dialog.alert({
          message: text,
          messageAlign: "left",
        });

      },
    }


  }
</script>

<style scoped>
  .box_list{
    display: inline-block;
    border:1px solid #1989fa;
    padding: 2px;
    color:cornflowerblue;
  }
  .van-nav-bar__title{
    font-size: 14px !important;
  }
  .content {

    background-color: #FFFFFF;
  }

  #ticket_list {
    background-color: #FFFFFF;
  }

  .card {
    font-size: 14px;
  }

  #last {
    position: relative;
    text-align: right;
    padding-top: 20px;
    margin-top: -60px;
    margin-right: 20px;
  }

  #lastnum {
    display: inline-block;
    width: 40px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    text-align: center;
  }

  #numlist span .button_ {
    display: inline-block;
    width: 40px;
    height: 48px;
    line-height: 48px;
    font-size: 13px;
    text-align: center;
  }

  #numlist span {
    display: inline-block;
    width: 68px;
    height: 48px;
    line-height: 48px;
    font-size: 13px;
    text-align: center;
  }

  #numlist .total {
    text-align: left;
    width: 122px;
  }

  .xz {
    width: 60px;
    height: 30px;
    background: #fffbe8;
    color: #ed6a0c !important;
  }

  .button_confirm {
    width: 90%;
    margin-left: 5%;
    margin-top: 60px;
    background-color: #1171CD;
    border: 0px;
  }

  .router {
    color: #646566;
  }

  .activerouter {
    color: #1989fa;
  }

  .loading {
    display: none;
  }


</style>



// WEBPACK FOOTER //
// src/system/index/wechatlist/wx_ticketList.vue